import { render, staticRenderFns } from "./RentalAppraisal.vue?vue&type=template&id=154fee04&scoped=true&"
import script from "./RentalAppraisal.vue?vue&type=script&lang=ts&"
export * from "./RentalAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fee04",
  null
  
)

export default component.exports